// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4c67680a","455":"07379bb2","977":"835311fc"}[chunkId] + ".chunk.js";
};